"use strict";
// (C) 2019-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearPreparedExecutionByRef = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var errorHandling_1 = require("../../../utils/errorHandling");
var executionResult_1 = require("./executionResult");
var ExecutionConverter_1 = require("../../../convertors/toBackend/afm/ExecutionConverter");
var api_1 = require("../../../utils/api");
var FilterConverter_1 = require("../../../convertors/toBackend/afm/FilterConverter");
var BearPreparedExecutionByRef = /** @class */ (function () {
    function BearPreparedExecutionByRef(authCall, definition, insight, filters, executionFactory) {
        if (filters === void 0) { filters = []; }
        this.authCall = authCall;
        this.definition = definition;
        this.insight = insight;
        this.filters = filters;
        this.executionFactory = executionFactory;
    }
    BearPreparedExecutionByRef.prototype.execute = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var execution;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createVisualizationExecution()];
                    case 1:
                        execution = _a.sent();
                        return [2 /*return*/, this.authCall(function (sdk) {
                                return sdk.execution
                                    ._getVisExecutionResponse(_this.definition.workspace, execution)
                                    .then(function (response) {
                                    return new executionResult_1.BearExecutionResult(_this.authCall, _this.definition, _this.executionFactory, response);
                                });
                            }, errorHandling_1.convertExecutionApiError)];
                }
            });
        });
    };
    BearPreparedExecutionByRef.prototype.explain = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                // eslint-disable-next-line no-console
                console.warn("Backend does not support explain mode");
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    BearPreparedExecutionByRef.prototype.createVisualizationExecution = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var uri, resultSpec, filters;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_1.objRefToUri(sdk_model_1.insightRef(this.insight), this.definition.workspace, this.authCall)];
                    case 1:
                        uri = _a.sent();
                        resultSpec = ExecutionConverter_1.convertResultSpec(this.definition);
                        filters = FilterConverter_1.convertFilters(this.filters);
                        return [2 /*return*/, {
                                visualizationExecution: {
                                    reference: uri,
                                    resultSpec: resultSpec,
                                    filters: filters,
                                },
                            }];
                }
            });
        });
    };
    BearPreparedExecutionByRef.prototype.withDimensions = function () {
        var dimsOrGen = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            dimsOrGen[_i] = arguments[_i];
        }
        return this.executionFactory.forDefinition(sdk_model_1.defWithDimensions.apply(void 0, tslib_1.__spreadArrays([this.definition], dimsOrGen)));
    };
    BearPreparedExecutionByRef.prototype.withSorting = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        return this.executionFactory.forDefinition(sdk_model_1.defWithSorting(this.definition, items));
    };
    BearPreparedExecutionByRef.prototype.withDateFormat = function (dateFormat) {
        return this.executionFactory.forDefinition(sdk_model_1.defWithDateFormat(this.definition, dateFormat));
    };
    BearPreparedExecutionByRef.prototype.withExecConfig = function (config) {
        if (!isEmpty_1.default(config === null || config === void 0 ? void 0 : config.dataSamplingPercentage)) {
            // eslint-disable-next-line no-console
            console.warn("Backend does not support data sampling, result will be not affected");
        }
        return this.executionFactory.forDefinition(this.definition);
    };
    BearPreparedExecutionByRef.prototype.fingerprint = function () {
        if (!this._fingerprint) {
            this._fingerprint = sdk_model_1.defFingerprint(this.definition);
        }
        return this._fingerprint;
    };
    BearPreparedExecutionByRef.prototype.equals = function (other) {
        return isEqual_1.default(this.definition, other.definition);
    };
    return BearPreparedExecutionByRef;
}());
exports.BearPreparedExecutionByRef = BearPreparedExecutionByRef;
//# sourceMappingURL=preparedExecutionByRef.js.map